import { Controller } from "stimulus"
import 'slim-select/dist/slimselect.css'

import SlimSelect from 'slim-select'

// Connects to data-controller="slim-select"
export default class extends Controller {
  connect() {
    new SlimSelect({
      select: this.element,
    })
  }
}
